import React from 'react';
import styled from 'styled-components';
import { theme } from '../styled/theme';
import { Container, H3, Flex } from '../styled/BaseComponents';
import { GradientTitle } from '../styled/BaseComponents';
import Icon from './Icon';

const SocialWrapper = styled.section`
  margin-top: 1.5rem;
  text-align: center;
`;

const SocialTitle = styled(GradientTitle)`

    text-align: center;
      margin: 16px 0;


`;

const SocialContainer = styled(Flex)`
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const SocialButton = styled.a`
  border: 1px solid ${theme.colors.border};
  background: ${theme.colors.card};
  padding: 10px 12px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${theme.colors.text};
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const SocialLabel = styled.span`
  font-weight: 700;
`;

export const SocialLinks = () => {
  const items = [
    {
      href: 'https://www.instagram.com/custodiyapp',
      label: 'Instagram',
      path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
    },
    {
      href: 'https://twitter.com/Custodiy1',
      label: 'X',
      path: 'M22 4.01h-3.7l-5.2 6.64L7.9 4.01H2l7.2 9.35L2.39 20h3.7l5.58-7.12L16.1 20H22l-7.66-9.9L22 4.01Z',
    },
    {
      href: 'https://t.me/custodiy_international',
      label: 'Telegram',
      path:
        'M22.5 2.2 1.9 10.1c-1 .4-1 1.6 0 2l5.2 2 2 6c.2.7 1.1.9 1.6.4l2.9-3 5.1 3.8c.7.5 1.7.1 1.9-.8l3-17.1c.2-.9-.7-1.6-1.5-1.3zM8.4 15.5l-.2 3.2 1.8-1.9 6.9-6.6c.3-.3-.1-.7-.5-.5L8.4 15.5z',
    },

  ];

  return (
    <SocialWrapper>
      <Container>
        <SocialTitle>Connect with us</SocialTitle>
        <SocialContainer>
          {items.map((item) => (
            <SocialButton key={item.href} href={item.href} target="_blank" rel="noreferrer">
              <Icon path={item.path} />
              <SocialLabel>{item.label}</SocialLabel>
            </SocialButton>
          ))}
        </SocialContainer>
      </Container>
    </SocialWrapper>
  );
};

export default SocialLinks;

